import Vue from "vue";
import Router from "vue-router";
import Login from "@/pages/login/view";
import Code from "@/pages/code/view";
import Index from "@/pages/index/view";
import TicketCode from "@/pages/code/TicketCode";
import Menu from "./menu";
import Mobile from "./mobile";
import YunMobile from "./yunMobile";
import Activiti from "@/pages/activiti/print";

Vue.use(Router);

const router = new Router({
  mode: "history",
  routes: [
    {
      path: "/login",
      name: "login",
      meta: {
        title: "道闸商户平台"
      },
      component: Login
    },
    {
      path: "/activiti",
      name: "activiti",
      meta: { name: "工作流" },
      component: Activiti
    },
    {
      path: "/code",
      name: "code",
      meta: {
        title: "道闸商户平台"
      },
      component: Code
    },
    {
      path: "/ticketCode/:busNo/:parkNo",
      name: "ticketCode",
      meta: {
        title: "道闸商户平台"
      },
      component: TicketCode
    },
    {
      path: "/",
      name: "index",
      component: Index,
      meta: {
        title: "道闸商户平台"
      },
      children: Menu,
      beforeEnter: (to, from, next) => {
        if (!localStorage["access_token"]) {
          next("/login");
        }
        if (to.path == "/") {
          next("/create");
        } else {
          next();
        }
      }
    },
    ...Mobile,
    ...YunMobile
  ]
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js